/*jshint esversion: 6 */

try {
    Typekit.load({
        async: true
    });
} catch (e) {}


document.addEventListener('DOMContentLoaded', () => {
    // move form inside the form wrapper
    const contactForm = document.querySelector('body:not(.dnnEditState) #dnn_BottomFormPane .LiveForm.Default');
    const contactFormTarget = document.querySelector('body:not(.dnnEditState) #js-form-target');

    if (contactForm && contactFormTarget) {
        contactFormTarget.appendChild(contactForm);
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
});

// Move Eyebrow content on breakpoint
const breakpoint = Number(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg').replace('rem','')*16);

function moveContent() {
    const desktopTarget = document.querySelector('#eyebrow-content > div');
    const mobileTarget = document.getElementById('eyebrow-mobile-target');
    const contentToMove = document.getElementById('eyebrow-nav-links');

    if (window.innerWidth >= breakpoint) { 
        desktopTarget.prepend(contentToMove);
    } else {
        mobileTarget.appendChild(contentToMove);
    }
}

// Anchor Scrolling
document.addEventListener('DOMContentLoaded', function () {
    // Initial execution on page load
    moveContent();

    // Event listener for window resize
    window.addEventListener('resize', moveContent);
    
    const headerHeight = 64; 

    function scrollToHash(hash) {
      const target = document.querySelector(hash);
      if (!target) return;
  
      const targetPosition = target.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = targetPosition - headerHeight;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  
    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const hash = this.hash;
        if (!hash) return;
  
        const linkUrl = new URL(this.href);
        const currentUrl = new URL(window.location.href);
  
        if (linkUrl.host === currentUrl.host && linkUrl.pathname === currentUrl.pathname) {
          e.preventDefault();
          scrollToHash(hash);
          history.pushState(null, null, hash);
        }
      });
    });
  
    window.addEventListener('load', function () {
      if (window.location.hash) {
        scrollToHash(window.location.hash);
      }
    });
});